module.exports = __webpack_public_path__ + "img/backup-recovery-ejaf-tech-canada.b82046a8.jpg";